const DEFAULT_REDIRECT = "/"

export function getSafeRedirectPath(
  redirect: string | null | undefined,
  fallback = DEFAULT_REDIRECT,
): string {
  if (!redirect) {
    return fallback
  }
  if (!redirect.startsWith("/")) {
    return fallback
  }
  if (redirect.startsWith("//")) {
    return fallback
  }
  if (redirect.startsWith("/login")) {
    return fallback
  }
  return redirect
}
